import { Content } from 'antd/lib/layout/layout';
import React from 'react';
import { ChecklistItem, ChecklistItemPlacement } from '../../types';
import { Nullable, ReleaseStepComponentProps, StepRunComponentProps } from '../../typescriptHelpers';
import StepChecklistContainer from '../StepChecklistContainer';
import styles from '../styles/appStyles';

export interface ReleaseStepChecklistContainerProps extends ReleaseStepComponentProps {
    checklistItems: ChecklistItem[];
    stepRunComponentProps: Nullable<StepRunComponentProps>;
}

const ReleaseStepChecklistContainer: React.FC<ReleaseStepChecklistContainerProps> = (props) => {
    return (
        <Content
            style={{
                ...styles.innerContent,
            }}
        >
            <StepChecklistContainer
                {...props}
                items={props.checklistItems}
                placement={ChecklistItemPlacement.StepChecklist}
            />
        </Content>
    );
};

export default ReleaseStepChecklistContainer;
